var exports = {
  "k": "x31de4314--c52702--container",
  "N": "x31de4314--c52702--feature",
};

module.exports = exports;
